<template>

  <div class="container ">
    <div class="container scroll-box" style="overflow: scroll;" id="scrollBoxSix"  @mousewheel="debounce">
      <div class="container flexVC" style="min-height: 750px;" v-if="$store.state.isPc">
        <div style="height: 80px;"></div>
        <div style="width: 260px;height: 90px;" class="pR flexVC">
          <div class="title">趁早周边</div>
          <div class="w100 pR title-line-box">
            <div class="titleLine"></div>
            <div class="titleLine-animation"
                 :class="currentIndex == 6 ? 'titleLine-animation-index' : '' "></div>
          </div>
        </div>
        <div class="content">{{content}}</div>
        <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave" @click="moreClick">
          <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
          </div>
          <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
            <span>了解更多</span>
            <img :src="isHover ? whiteArrow : arrow"
                 style="width: 15px;height: 11px;margin-left: 5px;">
          </div>
        </div>
        <div class="flexWrap" style="width: 100%;margin-top: 60px;">
          <div class="pR fifth-container"  v-for="(item, index) in images"  :class="index == 1 ? 'marH16' : ''" @click="moreClick">
            <el-image
              class="fifth-box"
              :src="item"
              :fit="cover"></el-image>
          </div>
        </div>
        <div style="height: 60px;"></div>
      </div>
      <div class="container-m pR flexVC2"  v-if="!$store.state.isPc">
        <div style="height: 13.9%;"></div>
        <div style="width: 1.9rem;height: 0.6rem;" class="pR flexVC">
          <div class="title-m">趁早周边</div>
          <div class="w100 pR title-line-box-m">
            <div class="titleLine-m"></div>
            <div class="titleLine-animation-m"
                 :class="currentIndex == 6 ? 'titleLine-animation-index-m' : '' "></div>
          </div>
        </div>
        <div class="content-m" style="margin-top: 0.4rem;">{{content}}</div>
        <div class="btn-more-box-m flexHC2"  @click="moreClick">
          <span>了解更多</span>
          <img :src="isHover ? arrow : arrow"
               style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
        </div>

        <div class="w100m " style="margin-top: 1.2rem;">
          <swiper :watchOverflow="true" :options="swiperOption" @slideChangeTransitionEnd="swiperChange">
            <swiper-slide>
              <div class="w100m">
                <div class="pR fifth-container-m" @click="moreClick">
                  <el-image
                    class="fifth-box-m"
                    src="https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/icon_home_sixth_1.png"
                    :fit="cover"></el-image>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="w100m">
                <div class="pR fifth-container-m" @click="moreClick">
                  <el-image
                    class="fifth-box-m"
                    src="https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/icon_home_sixth_2.png"
                    :fit="cover"></el-image>
                </div>
              </div>
            </swiper-slide>
            <!--          <div class="swiper-pagination" slot="pagination"></div>-->
          </swiper>
          <div class="w100m flexHC2" style="margin-top: 0.4rem;" >
            <div class="w100m" v-for="(item,index) in pointArray" :class="index == activeIndex ? 'point-select' : 'point-default'"></div>
          </div>
        </div>

        <div style="height: 60px;"></div>
      </div>
      <shape-footer></shape-footer>
    </div>
  </div>
</template>

<script>
  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'
  import shapeFooter from '@/components/ShapeFooter'
  import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'

  export default {
    name: "HomeSixth",
    props: ["currentIndex"],
    data() {
      return {
        content: '从2011年第一本效率手册的诞生，到2016年SHAPE YOUR LIFE和SHAPE YOUR LIFE潇洒衣橱的创办，趁早一直在不断地扩充着自己的产品线，从多场景，多角度去支持使用者每天有计划有方向地持续积累，成为期待中的自己',
        isHover: false,
        whiteArrow: whiteArrow,
        arrow: arrow,
        cover: 'cover',
        pointArray: 2,
        activeIndex: 0,
        swiperOption: {
          parallax: true,
          initialSlide: 0,
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: 220,
          grabCursor: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        wxappImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/icon_home_wxapp.png',
        images: ['https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/icon_home_sixth_1.png','https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mock/icon_home_sixth_2.png'],
      }
    },


    components: {
      shapeFooter,
      Swiper,
      SwiperSlide
    },

    mounted() {
      window.addEventListener('scroll',function() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log('debounce-----------------addEventListener------------',scrollTop)
      })
    },

    watch: {
      currentIndex(val) {
      }
    },

    methods: {
      swiperChange(e) {
        this.activeIndex = e.activeIndex
      },
      debounce(e) {
        window.scrollTo(0,0);
        console.log('debounce-----------------debounce------------',e)

        var testDiv = document.getElementById('scrollBoxSix');
        var divScrollTop = testDiv.scrollTop;
        var divClientHeight = testDiv.clientHeight;
        var divScrollHeight = testDiv.scrollHeight;
        if (divScrollTop + divClientHeight >= divScrollHeight && e.wheelDelta < 0) {
          console.log('到底部了');
          // this.$emit('scrollListener', '1')
        }
        if (divScrollTop == 0  && e.wheelDelta > 0) {
          console.log('到顶部了');
          this.$emit('scrollListener', '1')
        }
        // document.getElementById('scrollBox').scrollTop = 150 * 10;
        // document.getElementById('scrollBox').scrollLeft = 150 * 10;
      },
      moreEnter(e) {
        this.isHover = true
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
      moreClick(){
        this.$store.commit('editIndex', 4)
        this.$store.commit('edit',1)
        this.$store.commit('slideEdit',true)
        this.$router.push({
          path: '/periphery',
          query: {
            index: 1
          }
        })
      },
    },
  }
</script>

<style scoped>

  .title {
    width: 260px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -130px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 245px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content{
    max-width: 1000px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 40px;
    text-align: center;
    margin-top: 40px;
  }

  .fifth-box{
    width: 32.00vw;
    height: auto;
    cursor: pointer;
  }
  .fifth-container{
    width: auto;
    height: auto;
  }

  .fifth-container:hover:after{
    width: 100%;
    height: 100%;
    padding: 0;
    background: rgba(0,0,0,.8);
    content: '了解更多';
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .marH16{
    margin: 0 16px;
  }

  .marL16{
    margin-left: 16px;
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    /*overflow: hidden;*/
  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    margin-top: 32px;
    border: 1px solid #000000;
    color: #000000;
    position: relative;
    cursor: pointer;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(245px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(245px);
    }
  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }







  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
    text-align: justify;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }


  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    margin-top: 0.48rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }

  .home-item {
    width: 5.34rem;
    height: 2.92rem;
    background: #ffffff;
  }

  .cover-m {
    width: 1.92rem;
    height: 1.92rem;
    margin-left: 0.2rem;
    margin-top: 0.2rem;
  }

  .time-box-m {
    width: 68.56%;
    height: 2.32rem;
    background: #ffffff;
    position: relative;
    margin-left: 0.2rem;
  }


  .time-title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.32rem;
    line-height: 0.32rem;
  }

  .time-subtitle-m {
    font-size: 0.24rem;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 0.1rem;
  }

  .time-content-m {
    width: 90%;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
    margin-top: 0.15rem;
    text-align: justify;
  }



  .fifth-box-m{
    width: 5.58rem;
    height: 4rem;
    cursor: pointer;
  }

  .swiper-container{
    transform: translateX(-2.2rem);
  }


  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .point-default{
    width: 0.1rem;
    height: 0.1rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    margin-right: 0.08rem;
  }

  .point-select{
    width: 0.24rem;
    height: 0.1rem;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 0.06rem;
    margin-right: 0.08rem;
  }

  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /*  *************************************************************************************/
.scroll-box{
  overflow: scroll;
}

</style>



// WEBPACK FOOTER //
// src/page/home/components/HomeSixth.vue